import axios from "axios";
import Const from "../utils/constant";

const API_BASE_URL = Const.API.API_BASE_URL;

export const getLeads = async () => {
  try {
    const token = localStorage.getItem(Const.STORAGE_KEYS.TOKEN);
    const response = await axios.get(`${API_BASE_URL}/leads`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const deleteLead = async (id) => {
  try {
    const token = localStorage.getItem(Const.STORAGE_KEYS.TOKEN);
    const response = await axios.delete(`${API_BASE_URL}/leads/${id}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};
